import type { PressEvent } from "react-aria-components";

/**
 * Nur Antippen löst aus (Anforderungen N-03, oberflaeche/08 „Eine Wischbewegung über die Startansicht löst keine
 * Meldung aus“): React Aria meldet `onPress` beim Loslassen innerhalb der Fläche, auch nach einer Wischbewegung, die in
 * derselben Kachel beginnt und endet. Ein Fingertipp, der sich zwischen Aufsetzen und Loslassen weiter als die
 * Einrastweite bewegt (design/README §10.1: 10 px, so weit ordnet Chrome eine Berührung noch einem Ziel zu), gilt als
 * Wischen und löst nichts aus. Tastatur und Hilfsmittel (`keyboard`, `virtual`) lösen immer aus.
 */
const EINRASTWEITE_PX = 10;

interface Zeiger {
  id: number;
  x: number;
  y: number;
  bewegt: boolean;
}

let letzter: Zeiger | null = null;

if (typeof window !== "undefined") {
  window.addEventListener("pointerdown", (e) => {
    letzter = { id: e.pointerId, x: e.clientX, y: e.clientY, bewegt: false };
  }, { capture: true, passive: true });
  window.addEventListener("pointermove", (e) => {
    if (letzter && letzter.id === e.pointerId && !letzter.bewegt
      && Math.hypot(e.clientX - letzter.x, e.clientY - letzter.y) > EINRASTWEITE_PX) {
      letzter.bewegt = true;
    }
  }, { capture: true, passive: true });
}

/** `true`, wenn das Drücken ein Antippen war (kein Wischen); nur dann darf die Kachel auslösen. */
export function istAntippen(e: PressEvent): boolean {
  if (e.pointerType === "keyboard" || e.pointerType === "virtual") return true;
  return !letzter?.bewegt;
}
